(function () {
  const APP_VARIANT_ID = 52286607032690;
  const SELLING_PLAN_ID = 690873762162;

  const initialized = new WeakSet();
  let isAddingTrial = false;

  function getUpsellRoots() {
    return Array.from(document.querySelectorAll('.cart-app-upsell-compact'));
  }

  function setButtonLoadingState(button, loading) {
    if (!button) return;
    const btnText = button.querySelector('.btn-text');
    const btnLoading = button.querySelector('.btn-loading');
    button.disabled = loading;
    if (btnText) btnText.style.display = loading ? 'none' : 'inline';
    if (btnLoading) btnLoading.style.display = loading ? 'inline' : 'none';
  }

  function syncAllButtonStates() {
    getUpsellRoots().forEach((upsellRoot) => {
      const addButton = upsellRoot.querySelector('.app-add-btn');
      setButtonLoadingState(addButton, isAddingTrial);
    });
  }

  function setAddingTrialState(loading) {
    isAddingTrial = loading;
    syncAllButtonStates();
  }

  function fetchCart() {
    return fetch('/cart.js').then((res) => {
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    });
  }

  function setVisibility(upsellRoot, visible) {
    upsellRoot.style.display = visible ? 'block' : 'none';
    if (visible) {
      const addButton = upsellRoot.querySelector('.app-add-btn');
      setButtonLoadingState(addButton, isAddingTrial);
    }
  }

  function applyVisibilityFromCart(upsellRoot, cart) {
    const hasApp = cart.items.some((item) => item.variant_id === APP_VARIANT_ID);
    setVisibility(upsellRoot, !hasApp && cart.item_count > 0);
  }

  function syncUpsellVisibility(upsellRoot) {
    return fetchCart()
      .then((cart) => {
        applyVisibilityFromCart(upsellRoot, cart);
        return cart;
      })
      .catch(() => {});
  }

  function syncAllUpsellsVisibility() {
    return fetchCart()
      .then((cart) => {
        getUpsellRoots().forEach((upsellRoot) => applyVisibilityFromCart(upsellRoot, cart));
        return cart;
      })
      .catch(() => null);
  }

  function waitUntilAppInCart(maxAttempts, delayMs) {
    let attempts = 0;

    return new Promise((resolve, reject) => {
      function check() {
        attempts += 1;
        fetchCart()
          .then((cart) => {
            const hasApp = cart.items.some((item) => item.variant_id === APP_VARIANT_ID);
            if (hasApp) {
              resolve(cart);
              return;
            }
            if (attempts >= maxAttempts) {
              reject(new Error('App trial not confirmed in cart yet'));
              return;
            }
            setTimeout(check, delayMs);
          })
          .catch(() => {
            if (attempts >= maxAttempts) {
              reject(new Error('Unable to confirm app trial in cart'));
              return;
            }
            setTimeout(check, delayMs);
          });
      }

      check();
    });
  }

  function bindAddButton(upsellRoot) {
    const addButton = upsellRoot.querySelector('.app-add-btn');
    if (!addButton) return;

    addButton.addEventListener('click', function () {
      if (isAddingTrial) return;
      setAddingTrialState(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: APP_VARIANT_ID,
              quantity: 1,
              selling_plan: SELLING_PLAN_ID,
            },
          ],
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Failed to add trial');
          return res.json();
        })
        .then(() => {
          return waitUntilAppInCart(12, 250);
        })
        .then(() => {
          return syncAllUpsellsVisibility();
        })
        .then(() => {
          setAddingTrialState(false);

          // Keep drawer state and let theme sections refresh via pub/sub + app listeners.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-app-upsell' });
          }
          try {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'cart-app-upsell' } }));
            document.dispatchEvent(new CustomEvent('shopify:cart:update', { bubbles: true, detail: { source: 'cart-app-upsell' } }));
          } catch (_) {}
        })
        .catch((err) => {
          console.error('Error adding app:', err);
          setAddingTrialState(false);
          alert('Error adding trial. Please try again.');
        });
    });
  }

  function initUpsell(upsellRoot) {
    if (initialized.has(upsellRoot)) {
      syncUpsellVisibility(upsellRoot);
      return;
    }
    initialized.add(upsellRoot);
    bindAddButton(upsellRoot);
    syncUpsellVisibility(upsellRoot);
  }

  function initAll() {
    document.querySelectorAll('.cart-app-upsell-compact').forEach(initUpsell);
  }

  /** Drawer/cart sections replace HTML via AJAX; new nodes need listeners. */
  function onCartUpdate() {
    document.querySelectorAll('.cart-app-upsell-compact').forEach(initUpsell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', onCartUpdate);
  document.addEventListener('shopify:cart:update', onCartUpdate);
})();
